import { useEffect, type MouseEvent } from 'react'

/** Any address the app does not serve. */
export function NotFound({ onHome }: { onHome: () => void }) {
  useEffect(() => {
    document.title = 'Not found'
  }, [])
  const home = (e: MouseEvent<HTMLAnchorElement>) => {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return
    e.preventDefault()
    onHome()
  }
  return (
    <>
      <div className="card">
        <p className="empty" data-icon="search_off">
          Not found
        </p>
        <p className="link-row">
          <a className="btn text" data-icon="arrow_back" href="/" onClick={home}>
            Back to a new order
          </a>
        </p>
      </div>
      <p>Sorry, the content you are looking for does not exist.</p>
    </>
  )
}
